import { render, staticRenderFns } from "./ed-presentation-mode-task.component.vue?vue&type=template&id=7fb7e954&scoped=true&"
import script from "./ed-presentation-mode-task.component.ts?vue&type=script&lang=ts&"
export * from "./ed-presentation-mode-task.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-presentation-mode-task.component.scss?vue&type=style&index=0&id=7fb7e954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb7e954",
  null
  
)

export default component.exports